import { graphql } from "gatsby";
import React, { type FC, type HTMLAttributes } from "react";
import { useAuth } from "../../context/auth/AuthProvider";

import {
	IframeEmbedContent,
	extractPrintImageData,
} from "../IframeEmbedContent";
import { MembershipGateContainer } from "../MembershipGateContainer";

interface Props extends HTMLAttributes<HTMLElement> {
	node?: Queries.EmbedParagraphDataFragment;
}

// NOTE: Some scripts can throw an error on mount when running the dev environment, but not present in the production build.
export const Component: FC<Props> = ({ node, className, ...rest }) => {
	const { isLoggedIn } = useAuth();
	if (!node?.field_embed_code?.processed) return null;

	if (node?.field_gated_content && !isLoggedIn) {
		return <MembershipGateContainer variant="media" reason="no-account" />;
	}

	return (
		<IframeEmbedContent
			className={className}
			embedHtml={node.field_embed_code.processed}
			printImage={extractPrintImageData(node)}
			{...rest}
		/>
	);
};

export const IframeEmbedParagraph = React.memo(Component);

export const fragment = graphql`
    fragment EmbedParagraphData on paragraph__iframe_embed {
        __typename
        id
        field_gated_content
        field_embed_code {
            processed
        }
        ...EmbedParagraphPrintImage
    }
`;

export default IframeEmbedParagraph;
